import { useQuery, useMutation, useQueryClient, type UseQueryResult, type UseMutationResult } from '@tanstack/react-query';
import { fetchOutlookQueue, assignOutlookMessage, type OutlookQueueItem } from '../../services/outlook/outlookConnectionService';
import { LIVE } from '../../lib/queryPresets';

const OUTLOOK_QUEUE_KEY = ['outlook', 'queue'] as const;

export function useOutlookQueue(): UseQueryResult<OutlookQueueItem[]> {
  return useQuery({ ...LIVE, queryKey: OUTLOOK_QUEUE_KEY, queryFn: fetchOutlookQueue }); // file d'attente partagée entre avocats, pas de Realtime dessus
}

export function useAssignOutlookMessage(): UseMutationResult<void, Error, { processedMessageId: string; dossierId: string }> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ processedMessageId, dossierId }) => assignOutlookMessage(processedMessageId, dossierId),
    onSuccess: () => { qc.invalidateQueries({ queryKey: OUTLOOK_QUEUE_KEY }); },
  });
}
